import { useRouteError } from "react-router";
import { Button, Result, Typography } from "antd";
import { analyticsLogEvent } from "../../data/firebase/analytics";

const { Paragraph } = Typography;

interface ErrorProps {
  message?: string;
}

export default function Error({ message }: ErrorProps) {
  const error = useRouteError();
  const text = message || JSON.stringify(error);

  analyticsLogEvent("error_rendered", { error: text });

  return (
    <Result
      status="404"
      title="Oops!"
      subTitle={
        <>
          <Paragraph>Sorry, something went wrong</Paragraph>
          <Paragraph>{text}</Paragraph>
        </>
      }
      extra={
        <Button type="primary" href="/">
          Back Home
        </Button>
      }
    />
  );
}
